// ----------------------------------------------------------------------------
// Template: Ajaxify Cart Page
// ----------------------------------------------------------------------------

import { formatMoney }        from '@shopify/theme-currency';
import { cartSubtotalUpdate } from 'snippets/cart-js/ajax-add-cart';

Shopify.AjaxifyCartPage = () => {

    const _config = {
        itemQuantitySelector    : '.cart__quantity',
        itemRemoveBtn           : '.cart__remove--ajax',
        shopifyAjaxCartURL      : window.localeUrl+'/cart.js',
        quantityInputDelayTime  : 500, // in miliseconds
        cartSubtotalSelector    : '.cart__subtotal-price',
        cartUndoMessageSelector : '.cart__undo-message',
        cartUndoButton          : '.cart__undo--ajax',
        checkoutButton          : '[name="checkout"]',
    };

    const _getInventory = () => {
        return fetch(window.localeUrl+'/cart?view=max-qty');
    };

    const _removeLineItem = (lineItemRemoveBtn) => {
        // Get the line item info
        const selectedLineItemKey = lineItemRemoveBtn.dataset.lineItemKey;
        const selectedLineItemId = lineItemRemoveBtn.dataset.lineItemId;
        const selectedLineItemProperties = lineItemRemoveBtn.dataset.lineItemProperties;
        const selectedLineItemTitle = lineItemRemoveBtn.dataset.lineItemTitle;
        const selectedLineItemQuantity = lineItemRemoveBtn.dataset.lineItemQuantity;
        const cartItemTotalPrice = document.querySelectorAll('.cart__item--total-wrapper .product__price');
        const cartRow = lineItemRemoveBtn.closest('.cart__row');

        // Remove the line item by updating its quantity to 0
        fetch(window.localeUrl + '/cart/change.js', {
            method: 'POST',
            body: JSON.stringify({ quantity: 0, id: selectedLineItemKey }),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(() => {
                if (lineItemRemoveBtn.dataset.undo == "false") { // If removing an out of stock product - refresh the page
                    location.reload();
                } else {
                    document.querySelectorAll('.cart__item--total-wrapper .product__price').forEach((element) => {
                        element.classList.add('loading');
                    });
                    document.querySelectorAll('.cart-info__subtotal').forEach((subtotal => subtotal.classList.add('loading')));
                    document.querySelector('.cart__subtotal-price').classList.add('loading');

                    // Update free shipping progress
                    // Shopify.freeShippingProgress().init();

                    // Remove line item row
                    cartRow.remove();

                    fetch(_config.shopifyAjaxCartURL, {
                        cache: 'no-cache',
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                        .then(response => response.json())
                        .then((cart) => {
                            const cartSubtotal = formatMoney(cart.items_subtotal_price, theme.settingCurrencyFormat);
                            document.querySelector(_config.cartSubtotalSelector).textContent = cartSubtotal;

                            cartSubtotalUpdate(cart);

                            // Generate Undo message
                            let message = '';

                            message += '<p>';
                            message += selectedLineItemTitle + ' ' + window.translations.cartProductRemovedMessage + ' ';
                            message += `<button type="button" class="cart__undo cart__undo--ajax" data-line-item-id="${selectedLineItemId}" data-line-item-quantity="${selectedLineItemQuantity}" data-line-item-properties="${selectedLineItemProperties}" >`;
                            message += ' ' + window.translations.cartUndoLabel;
                            message += '?</button>';
                            message += '</p>';

                            const cartUndoMessageSelector = document.querySelector(_config.cartUndoMessageSelector);

                            if (cartUndoMessageSelector.innerHTML === '') {
                                cartUndoMessageSelector.innerHTML = message;
                            } else {
                                cartUndoMessageSelector.classList.remove('js--fade-in');
                                cartUndoMessageSelector.innerHTML = message;
                                cartUndoMessageSelector.classList.add('js--fade-in');
                            }

                            cartItemTotalPrice.forEach((item) => {
                                item.classList.remove('loading');
                            });
                            document.querySelectorAll('.cart-info__subtotal').forEach((subtotal => subtotal.classList.remove('loading')));
                            document.querySelector('.cart__subtotal-price').classList.remove('loading');
                            document.querySelector(_config.cartUndoButton)?.addEventListener('click', (e) => {
                                const undoButton = e.currentTarget;
                                _undoRemovedItem(undoButton);
                            });
                        });

                    setTimeout(() => {
                        cartItemTotalPrice.forEach((item) => {
                            item.classList.remove('loading');
                        });
                        document.querySelectorAll('.cart-info__subtotal').forEach((subtotal => subtotal.classList.remove('loading')));
                        document.querySelector('.cart__subtotal-price').classList.remove('loading');
                    }, 1000);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const _undoRemovedItem = (undoButton) => {
        // Get the line item id
        const selectedLineItemId       = undoButton.dataset.lineItemId;
        const selectedLineItemQuantity = undoButton.dataset.lineItemQuantity;
        const selectedLineItemPropertiesBefore = undoButton.dataset.lineItemProperties;
        // Pass a function to map
        const selectedMap = selectedLineItemPropertiesBefore.slice(0, -1);
        const selectedMap1 = selectedMap.split(',');
        const selectedMap2 = selectedMap1.map(lineItemInfo => lineItemInfo.split(':'));

        const mapped = selectedMap2.map(item => ({
            [item[0]]: item[1]
        }));
        const selectedLineItemProperties = Object.assign({}, ...mapped);

        fetch(window.localeUrl+'/cart/add.js', {
            method: 'POST',
            body: JSON.stringify({ items: [ {quantity: selectedLineItemQuantity, id: selectedLineItemId, properties: selectedLineItemProperties } ] }),
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
                if(response.status!==200) {
                    throw response;
                } else {
                    return response.json();
                }
            })
            .then((data) => location.reload())
            .catch(async (error) => {
                try {
                    const errorObject = await error.json();
                    if (errorObject?.description) {
                        const errorDescription = errorObject.description;
                        document.querySelector(_config.cartUndoMessageSelector).textContent(errorDescription);
                        return;
                    }
                } catch {
                    console.error(error);
                }
            });
    };

    const _init = function() {

        // Attach remove function to all line items.
        const removeButtons = document.querySelectorAll(_config.itemRemoveBtn);
        removeButtons.forEach((removeButton) => {
            removeButton?.addEventListener('click', function(e){
                e.preventDefault();
                _removeLineItem(e.currentTarget);
            });
        });

        // Add Update Quantity Funcionality to all Line Items.
        const quantitySelectors = document.querySelectorAll(_config.itemQuantitySelector);
        quantitySelectors.forEach((itemQuantitySelector) => {
            let timeout;

            itemQuantitySelector.addEventListener('change', (e) => {
                const cartRow = itemQuantitySelector.closest('.cart__row');

                if(itemQuantitySelector.value == 0) {
                    const lineItem = itemQuantitySelector.closest('.cart__line-item');
                    const lineItemRemoveBtn = lineItem.querySelector(_config.itemRemoveBtn);
                    _removeLineItem(lineItemRemoveBtn);

                } else {
                    // If user input negative quantities, force input value to 1
                    if(itemQuantitySelector.value < 0) {
                        itemQuantitySelector.value = 1;
                    }
                    console.log('value before going through time async', itemQuantitySelector.value);
                    clearTimeout(timeout); // Clear existing timeout to make sure the event only runs once
                    timeout = setTimeout(async () =>{
                        const inventoryRawData = await _getInventory();
                        const inventories = await inventoryRawData.json();

                        const selectedLineItemKey                 = itemQuantitySelector.dataset.lineItemKey;
                        const selectedLineItemId                  = itemQuantitySelector.dataset.lineItemId;
                        const selectedLineItemPrice               = parseInt(itemQuantitySelector.dataset.price);
                        const selectedLineItemCompareAtPrice      = parseInt(itemQuantitySelector.dataset.compareAtPrice);
                        const selectedLineItemInventoryPolicy     = itemQuantitySelector.dataset.inventoryPolicy;
                        const selectedLineItemInventoryManagement = itemQuantitySelector.dataset.inventoryManagement;
                        const cartItemQuantity                    = itemQuantitySelector.closest('.cart__item--quantity');
                        const selectedLineItemTotalPriceSelector  = (cartItemQuantity != null) ? cartItemQuantity.nextElementSibling : null;


                        console.log('value after going through timeoutAsync', itemQuantitySelector.value);

                        Object.entries(inventories).forEach(([key, value]) => {
                            if (key === selectedLineItemId) {
                                const availableQty = parseInt(value);
                                let selectedQuantity = itemQuantitySelector.value;
                                let maxQuantityReached = false;

                                if (availableQty <= 0 && selectedLineItemInventoryPolicy !== 'continue' && selectedLineItemInventoryManagement !== 'none') {
                                    _config.checkoutButton.disabled = true;
                                    cartRow.querySelector('.cart__item--message').innerHTML = "<p>This item is no longer available. Please <a data-undo='false' href='' data-line-item-id='" + selectedLineItemId + "' class='cart__remove cart__remove--ajax'>remove this item</a> before continuing to checkout.</p>";
                                } else {
                                    if (availableQty < parseInt(itemQuantitySelector.value) && selectedLineItemInventoryPolicy !== 'continue' && selectedLineItemInventoryManagement !== 'none') {
                                        itemQuantitySelector.value = availableQty;
                                        selectedQuantity = availableQty;
                                        maxQuantityReached = true;
                                    } else {
                                        selectedQuantity = itemQuantitySelector.value;
                                    }
                                }


                                // Update data-line-item-quantity attribute for the remove button
                                cartRow.querySelector(_config.itemRemoveBtn).dataset.lineItemQuantity = selectedQuantity;
                                const selectedLineItemTotalPrice = formatMoney(selectedQuantity * selectedLineItemPrice, theme.moneyWithoutCurrency);

                                // Display Max Qty message if applicable
                                const maxQtyMessageElement = itemQuantitySelector.closest('.cart__item--quantity').querySelector('.js-maxReached');
                                if (maxQuantityReached) {
                                    if (maxQtyMessageElement === null) {
                                        const node = document.createElement('p');
                                        node.classList.add('cart__item--quantity__max-qty-message', 'js-maxReached');
                                        const message = document.createTextNode(`${window.translations.cartMaxQtyMessage}`);
                                        node.appendChild(message);

                                        itemQuantitySelector.closest('.cart__item--quantity').appendChild(node);
                                    }
                                } else {
                                    if (maxQtyMessageElement !== null) {
                                        maxQtyMessageElement.remove();
                                    }
                                }

                                fetch(window.localeUrl + '/cart/change.js', {
                                    method: 'POST',
                                    body: JSON.stringify({ quantity: selectedQuantity, id: selectedLineItemKey }),
                                    headers: {
                                        'Content-Type': 'application/json'
                                    }
                                }).then(() => {
                                    document.querySelectorAll('.cart__item--total-wrapper .product__price').forEach(element => {
                                        element.classList.add('loading');
                                    });
                                    document.querySelectorAll('.cart-info__subtotal').forEach((subtotal => subtotal.classList.add('loading')));
                                    document.querySelector('.cart__subtotal-price').classList.add('loading');

                                    // Update free shipping progress
                                    // Shopify.freeShippingProgress().init();

                                    fetch(_config.shopifyAjaxCartURL, {
                                        cache: 'no-cache',
                                        headers: {
                                            'Content-Type': 'application/json'
                                        }
                                    })
                                        .then(response => response.json())
                                        .then(cart => {

                                            const cartSubtotal = formatMoney(cart.items_subtotal_price, theme.settingCurrencyFormat);
                                            document.querySelector(_config.cartSubtotalSelector).textContent = cartSubtotal;

                                            selectedLineItemTotalPriceSelector.querySelector('.cart__item--total-price').textContent = selectedLineItemTotalPrice;

                                            if (selectedLineItemCompareAtPrice > selectedLineItemPrice) {
                                                const selectedLineItemSaleTotalPrice = formatMoney(selectedQuantity * selectedLineItemCompareAtPrice, theme.moneyWithoutCurrency);
                                                selectedLineItemTotalPriceSelector.querySelector('.product__price--total-sale').textContent = selectedLineItemSaleTotalPrice;
                                            }

                                            cartSubtotalUpdate(cart);

                                            setTimeout(() => {
                                                const productPrices = document.querySelectorAll('.cart__item--total-wrapper .product__price');
                                                productPrices.forEach((productPrice) => {
                                                    productPrice.classList.remove('loading');
                                                });
                                                document.querySelectorAll('.cart-info__subtotal').forEach((subtotal => subtotal.classList.remove('loading')));
                                                document.querySelector('.cart__subtotal-price').classList.remove('loading');
                                            }, 1500);
                                        });
                                })
                                    .catch((error) => {
                                        console.error(error);
                                    });
                            }
                        });
                    }, _config.quantityInputDelayTime);
                }
            });
        });

    };
    return {
        init: (params) => {
            // Configuration
            params = params || {};
            // Merging with defaults.
            Object.assign(_config, params);
            // Action
            _init();
        },
        getConfig: () => {
            return _config;
        }
    };
};

document.addEventListener('DOMContentLoaded', () => {
    Shopify.AjaxifyCartPage().init();
});
